<template>
    <div class="container">
        <PcHeader></PcHeader>
        <div class="container-inner" v-if="datalang == '中文简体'">
            <div class="top">
                <img src="../../../assets/images/svip_zh_title.png" alt="">
            </div>
            <div class="content">
                <img src="../../../assets/images/svip_zh_content.png" alt="">
            </div>
        </div>

        <div class="container-inner" v-if="datalang == 'English'">
            <div class="top">
                <img src="../../../assets/images/svip_en_title.png" alt="">
            </div>
            <div class="content">
                <img src="../../../assets/images/svip_en_content.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import PcHeader from "../../../components/pc/Header.vue"

export default {
    components: {
        PcHeader,
    },
    data() {
        return {
            datalang: '',   //路由语言判断
        }
    },
    created() {
        this.$EventBus.$on('this.languageValue', (data) => {
            this.datalang = data
        })
    },
    mounted() {
        // console.log('当前语言：',this.datalang)
    }
}
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    .container-inner{
        width: 1200px;
        margin: 0 auto;
        .top{
            width: 100%;
            position: sticky;
            top: 0;
            background-color: white;
            img{
                width: 100%;
            }
        }
        .content{
            width: 100%;
            img{
                width: 100%;
                margin-bottom: 100px;
            }
        }
    }
}
</style>